import { timePanelSharedProps as e } from "./index634.js";
import { buildProps as r, definePropType as o } from "./index601.js";
const i = r({
  ...e,
  datetimeRole: String,
  parsedValue: {
    type: o(Object)
  }
});
export {
  i as panelTimePickerProps
};
